<template>

    <table v-if="selectedComponent" class="table mt-2 border-bottom" style="margin-bottom: 0px;font-size: .85rem;">
        <tbody>

        <tr class="info-row">
            <td colspan="2" class="editor-content bg-primary text-white"><strong>Component - Button</strong></td>
        </tr>

        <label-editor :selected-component="selectedComponent"></label-editor>

        <tr>
            <td class="editor-content editor-label">Size</td>
            <td class="editor-content">
                <select class="form-control editor-form editor-select" v-model="selectedComponent.style.size">
                    <option value="size-sm">small</option>
                    <option value="size-md">standard</option>
                    <option value="size-lg">large</option>
                </select>
            </td>
        </tr>

        <label-size-editor :selected-component="selectedComponent"></label-size-editor>

        <min-max-width-height-editor v-if="selectedComponent"
                                     :selected-component="selectedComponent"
                                     property="minWidth"></min-max-width-height-editor>

        <border-radius-editor v-if="selectedComponent"
                              :selected-component="selectedComponent"></border-radius-editor>

        <context-color-editor :selected-component="selectedComponent" label="Color"></context-color-editor>

        <tr v-if="selectedComponent && isCustomColor">
            <td class="editor-content editor-label">Custom color</td>
            <td class="editor-content">
                <color-picker :color-object="selectedComponent.style" color-field="color" class="mt-1" :shift-left="true"></color-picker>
            </td>
        </tr>

        <context-color-editor v-if="isCustomColor" :selected-component="selectedComponent" label="Background Color"></context-color-editor>

        <tr v-if="isCustomColor && isCustomBackgroundColor">
            <td class="editor-content editor-label">Custom background color</td>
            <td class="editor-content">
                <color-picker :color-object="selectedComponent.style" color-field="backgroundColor" class="mt-1"
                              :shift-left="true"></color-picker>
            </td>
        </tr>

        <tr v-if="selectedComponent">
            <td class="editor-content editor-label">Action</td>
            <td class="editor-content">
                <select class="form-control editor-form editor-select" v-model="selectedComponent.action">
                    <option v-for="action in buttonActions">{{action}}</option>
                </select>
            </td>
        </tr>

        <!-- Use the resource for next view because it is more robust and exists already -->
        <website-link-properties v-if="selectedComponent && selectedComponent.action === 'save'"
                                 :selected-component="selectedComponent" resource-label="Next"></website-link-properties>

<!--        <tr v-if="selectedComponent && selectedComponent.action === 'save'">-->
<!--            <td class="editor-content editor-label">Next View</td>-->
<!--            <td class="editor-content">-->
<!--                <select class="form-control editor-form editor-select" v-model="selectedComponent.redirectTo"-->
<!--                        @change="onViewSelected">-->
<!--                    <option v-for="view in views" :value="view.id">{{view.name}}</option>-->
<!--                </select>-->
<!--            </td>-->
<!--        </tr>-->

        <view-link-properties v-if="view && isLinkable" :view="view" :selected-component="selectedComponent"></view-link-properties>

        <website-link-properties v-else-if="isLinkable" :page="page" :selected-component="selectedComponent"></website-link-properties>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Margin</td>
        </tr>

        <margin-selector :spacing="selectedComponent.margin"></margin-selector>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Padding</td>
        </tr>

        <margin-selector :spacing="selectedComponent.padding"></margin-selector>

        </tbody>
    </table>
</template>

<script>
    import LayoutFactory from "../../utils/LayoutFactory";
    import LayoutUtil from "../../utils/LayoutUtil";
    import ContextColorEditor from "./ContextColorEditor.vue";
    import MarginSelector from "./MarginSelector.vue";
    import ColorPicker from "../../components/ColorPicker.vue";
    import TextAlignSelector from './TextAlignSelector.vue'
    import BorderRadiusEditor from './BorderRadiusEditor.vue'
    import MinMaxWidthHeightEditor from './MinMaxWidthHeightEditor.vue'
    import ViewLinkProperties from "./ViewLinkProperties.vue";
    import WebsiteLinkProperties from "./WebsiteLinkProperties.vue";
    import LabelEditor from "./LabelEditor.vue";
    import LabelSizeEditor from "./LabelSizeEditor.vue";

    export default {
        name: 'ButtonProperties',
        components: {
            LabelSizeEditor,
            LabelEditor,
            WebsiteLinkProperties,
            ViewLinkProperties,
            ColorPicker,
            MarginSelector,
            ContextColorEditor,
            TextAlignSelector,
            BorderRadiusEditor,
            MinMaxWidthHeightEditor
        },
        props: ['layout', 'view', 'page', 'component'],
        data() {
            return {
                model: webase.model,
                factory: new LayoutFactory(),
                layoutUtil: new LayoutUtil()
            }
        },
        computed: {
            isCustomColor() {
                return this.selectedComponent.style && this.selectedComponent.style.color && (this.selectedComponent.style.color === 'custom' || this.selectedComponent.style.color.indexOf('#') === 0)
            },
            isCustomBackgroundColor() {
                return this.selectedComponent.style && this.selectedComponent.style.backgroundColor && (this.selectedComponent.style.backgroundColor === 'custom' || this.selectedComponent.style.backgroundColor.indexOf('#') === 0)
            },
            selectedComponent() {
                return this.component ? this.component : this.layout.selectedComponent
            },
            isLinkable() {
                return this.selectedComponent.action === 'link'
            },
            views() {
                let appViews = webase.managers.app.getViews()
                return appViews.filter(view => view.id !== this.view.id)
            },
            buttonActions() {
                return this.view ? this.model.actions : ['link']
            },
            urlVisible() {
                return this.selectedComponent.resourceType === 'URL'
            },
            linkLocationLabel() {
                return this.selectedComponent.resource ? this.selectedComponent.resource : 'select'
            }
        },
        mounted() {
        },
        methods: {
            onWidthSelected() {
                this.layoutUtil.setColumnWidths(this.column, this.layout.selectedRow.columns)
            },
            onViewSelected() {
                this.selectedComponent.resourceType = "View"
            },
            onEditAnimationClick() {
                webase.eventDispatcher.emit('editAnimationClick')
            }
        }
    }
</script>

<style>

</style>
